<template>

<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg3462"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs3466"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath3480"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path3478" /></clipPath></defs><g
     id="g3468"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g3470"
       transform="translate(258.1201,476.3799)"><path
         d="M 0,0 H -79.36"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path3472" /></g><g
       id="g3474"><g
         id="g3476"
         clip-path="url(#clipPath3480)"><g
           id="g3482"
           transform="translate(293.1201,476.3799)"><path
             d="m 0,0 h 161.01 c 9.27,0 16.79,-7.52 16.79,-16.79 v -36.939"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3484" /></g><g
           id="g3486"
           transform="translate(176.1099,207.7305)"><path
             d="M 0,0 H 19.44 V -53.73 H -114.88 V 0 H -35"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3488" /></g><path
           d="m 402.646,357.999 h -32.325 v 32.325 h 32.325 z"
           style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path3490" /><path
           d="m 370.321,325.674 h -32.325 v 32.325 h 32.325 z"
           style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path3492" /><path
           d="m 402.646,293.349 h -32.325 v 32.325 h 32.325 z"
           style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path3494" /><path
           d="m 370.321,261.023 h -32.325 v 32.325 h 32.325 z"
           style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path3496" /><path
           d="m 402.646,228.698 h -32.325 v 32.325 h 32.325 z"
           style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path3498" /><path
           d="m 370.321,196.373 h -32.325 v 32.325 h 32.325 z"
           style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path3500" /><path
           d="m 402.646,164.048 h -32.325 v 32.325 h 32.325 z"
           style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path3502" /><path
           d="m 370.321,131.723 h -32.325 v 32.325 h 32.325 z"
           style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path3504" /><g
           id="g3506"
           transform="translate(384.7832,35.6211)"><path
             d="m 0,0 h -28.923 c -6.201,0 -10.938,5.534 -9.98,11.661 l 6.944,44.446 c 0.769,4.918 5.004,8.543 9.98,8.543 h 15.035 c 4.976,0 9.212,-3.625 9.98,-8.543 L 9.98,11.661 C 10.938,5.534 6.201,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3508" /></g><g
           id="g3510"
           transform="translate(370.3213,100.2715)"><path
             d="M 0,0 V 322.378"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3512" /></g><g
           id="g3514"
           transform="translate(263.5,100.2695)"><path
             d="M 0,0 H 224.21 C 233.48,0 241,7.521 241,16.79 v 288.801 c 0,9.269 -7.52,16.79 -16.79,16.79 H -54.51 l -13.11,41.949 c -2.19,7.011 -8.68,11.78 -16.03,11.78 h -109.63 c -7.35,0 -13.84,-4.769 -16.03,-11.78 l -13.11,-41.949 h -16.79 c -9.27,0 -16.79,-7.521 -16.79,-16.79 V 16.79 C -256,7.521 -248.48,0 -239.21,0 H -35"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3516" /></g></g></g></g></svg>
</template>
